import { render, staticRenderFns } from "./OrderableItemFixtureEdit.vue?vue&type=template&id=9f58eba4&"
import script from "./OrderableItemFixtureEdit.vue?vue&type=script&lang=ts&"
export * from "./OrderableItemFixtureEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports